import { event } from '../../Foundation';

const PREVIEW_ANIMATION_SPEED = 600;

const toggleColors = (contentElem) => {
  const images = contentElem.querySelectorAll(`.preview-image`);
  const colors = Array.from(contentElem.querySelectorAll('.color'));
  let setActive;

  const selectColor = (evt) => {
    const id = evt.target.getAttribute('data-for');
    const image = contentElem.querySelector(`[data-id="${id}"]`);
    const animateImages = Array.from(contentElem.querySelectorAll('.preview-image--active'));
    const activeColors = Array.from(contentElem.querySelectorAll('.color--active'));

    const setActiveColor = () => {
      activeColors.forEach((item) => item.classList.remove('color--active'));
      evt.target.classList.add('color--active');
      document.body.click();
    };

    const setActivePreview = () => {
      if (image.classList.contains('preview-image--active')) {
        return;
      }

      image.classList.add('preview-image--animate');
      setActive = setTimeout(() => {
        animateImages.forEach((item) => item.classList.remove('preview-image--active'));
        image.classList.add('preview-image--active');
        image.classList.remove('preview-image--animate');
      }, PREVIEW_ANIMATION_SPEED);
    };

    const resetAnimation = () => {
      clearTimeout(setActive);
      images.forEach((item) => item.classList.remove('preview-image--animate'));
    };

    if (typeof setActive === 'number') {
      resetAnimation();
    }

    setActiveColor();
    setActivePreview();
  };

  colors.forEach((color) => {
    color.addEventListener('click', selectColor);
    color.addEventListener('mouseover', selectColor);
  });
};

const toggleTabs = (elem) => {
  const mql = window.matchMedia('(width >= 992px)');
  const tabs = Array.from(elem.querySelectorAll('.tab'));
  const select = elem.querySelector('.tab-select');
  const slider = elem.querySelector('.slider');

  if (!tabs.length) {
    return;
  }

  function moveSlider(tab) {
    if (!tab) {
      return;
    }

    const { offsetLeft, offsetWidth } = tab;
    slider.style.transform = `translateX(${offsetLeft}px)`;
    slider.style.setProperty('--tab-width', `${offsetWidth}px`);
  }

  const toggleContent = (id) => {
    const contents = Array.from(elem.querySelectorAll('.content-wrapper'));
    contents.forEach((content) => {
      content.classList.add('hidden');

      if (content.dataset.contentId === id) {
        content.classList.remove('hidden');
      }
    });
  };

  const updateSelected = (evt) => {
    const contentId = evt.target.dataset.contentId ?? evt.target.value;

    // Update tabs
    const tab = elem.querySelector(`.tabs [data-content-id="${contentId}"]`);
    elem.querySelector('.tab--active')?.classList.remove('tab--active');
    tab.classList.add('tab--active');
    moveSlider(tab);

    // Update dropdown
    const select = elem.querySelector('.tab-select');
    select.value = contentId;
    event.emit(select, 'refresh');

    toggleContent(contentId);
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', updateSelected);
  });

  select.addEventListener('change', updateSelected);

  mql.onchange = (evt) => {
    if (evt.matches) {
      moveSlider(elem.querySelector('.tab--active'));
    }
  };

  moveSlider(elem.querySelector('.tab--active'));
};

export const initFunctions = (elem) => {
  const colorSpot = elem;
  const contentsElem = Array.from(elem.querySelectorAll('.content-wrapper'));
  colorSpot.style.setProperty(
    '--color-spot--preview-animation-speed',
    `${PREVIEW_ANIMATION_SPEED}ms`,
  );

  // Toggle Tabs and Dropdown
  toggleTabs(colorSpot);

  contentsElem.forEach((elem) => {
    // Color preview
    toggleColors(elem);
  });
};
